import { render, staticRenderFns } from "./StudentQuizList.vue?vue&type=template&id=c4a5f550&scoped=true"
import script from "./StudentQuizList.vue?vue&type=script&lang=js"
export * from "./StudentQuizList.vue?vue&type=script&lang=js"
import style0 from "./StudentQuizList.vue?vue&type=style&index=0&id=c4a5f550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a5f550",
  null
  
)

export default component.exports